export default "__VITE_ASSET__CRFGkxnm__"